import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Apps, SupportTicketList, SupportTicketTitle } from "../../../constants";
import { SupportTicketSubTitle } from "../../../data/miscellaneous/SupportTicket";
import TicketList from "./TicketList";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import TicketTable from "./ticketTable";

const SupportTicketContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={SupportTicketTitle} parent={Apps} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SupportTicketList} span={SupportTicketSubTitle} tag />
              <CardBody>
                <TicketList />
                <TicketTable />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SupportTicketContainer;
